
export default function concatStr(item, length) {
    if(!item)
        return "";
    
    if (item.length > length){
        return item.substring(0,length); //add the extra spaces as needed
    } else {
        return item; // return the item because it's length is 12 or +
    }
}

